"use client";
import { useEffect } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import useLmsUserStatus from "@/lib/lms/getLmsUserStatus";
import useFeatureFlag from "@/lib/feature-flags/hooks/useFeatureFlag";

export default function DiscoverSearchRedirect() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const { lmsUserStatus, loading: lmsUserStatusLoading } = useLmsUserStatus();
  const { flagValue: enterpriseRedirectFlag } = useFeatureFlag(
    "NEXT_PUBLIC_FEATURE_AUTHX_ENTERPRISE_REDIRECT",
    "disable",
  );

  // Feature flag control
  const isEnterpriseRedirectEnabled = enterpriseRedirectFlag === "enable";

  // User status
  const isEnterpriseUser = lmsUserStatus?.isEnterpriseUser ?? false;

  // Combined logic for routing decision
  const shouldBypassAuthx = isEnterpriseRedirectEnabled && isEnterpriseUser;

  useEffect(() => {
    if (!lmsUserStatusLoading) {
      // Enterprise users should always go to /search, never /authx/search
      const basePath = shouldBypassAuthx ? "/search" : "/authx/search";
      const queryString = searchParams.toString();
      const destination = queryString ? `${basePath}?${queryString}` : basePath;

      router.replace(destination);
    }
  }, [lmsUserStatusLoading, shouldBypassAuthx, router, searchParams]);

  return <></>;
}
